var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list list_emoji"},_vm._l((_vm.emojis),function(emoji){return _c('li',{staticClass:"list__item",on:{"click":function($event){return _vm.selectEmoji(emoji.file)}}},[_c('img',{attrs:{"src":`${_vm.myUrl}/assets/emojis/${emoji.file}`,"alt":"emoji"}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }